export default {
  game:{
    pano:"./game/sala/unsolved.jpg",
    marks: [
      {
        id: "exit:lobby:0", // cmd, arg, marker id
        polylineRad: [
          [0.97, 0.07],
          [0.97, -0.2], 
          [1.18, -0.22],
          [1.18, 0.08],
          [0.97, 0.07]
        ],
        svgStyle: {
          fill: "rgba(250, 0, 0, 0.2)",
          stroke: "rgba(250, 0, 0, 0.95)",
          strokeWidth: "5px",
          // strokeDasharray: 5
        },
        tooltip: {
          content: "Regresa",
          position: "center bottom"
        }
      },
      {
        id: "mark1",
        polylineRad: [
          [5.984, 0.321],
          [5.96, -0.485],
          [0.55, -0.45],
          [0.53, 0.29],
          [5.984, 0.321]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(255, 255, 0, 0.95)",
          strokeWidth: "5px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "¡Ayúdanos a restaurar el cuadro!",
          position: "right bottom"
        }
      },
      {
        id: "mark2",
        polylineRad: [
          [1.185, 0.309],
          [1.185, -0.537],
          [2.210, -0.48],
          [2.179, 0.272],
          [1.185, 0.309]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(255, 255, 0, 0.95)",
          strokeWidth: "5px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "¡Ayúdanos a restaurar el cuadro!",
          position: "right bottom"
        }
      },
      {
        id: "mark3",
        polylineRad: [
          [2.48, 0.2],
          [2.475, -0.361],
          [3.24, -0.45],
          [3.233, 0.248],
          [2.48, 0.2]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 0, 0.0)",
          stroke: "rgba(255, 255, 0, 0.95)",
          strokeWidth: "5px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "¡Ayúdanos a restaurar el cuadro!",
          position: "right bottom"
        }
      },
      {
        id: "mark1Content",
        visible: false,
        polylineRad: [
          [4.495, 0.163],
          [4.49, -0.227],
          [4.646, -0.232],
          [4.64, 0.167],
          [4.495, 0.163]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Patricio Ramos",
          position: "right bottom"
        },
        info: {
          template: "mark1Content",
          images: [
            "galerias/gameRoom/PATRICIO.png"
          ]
        }
      },
      {
        id: "mark2Content",
        visible: false,
        polylineRad: [
          [4.645, 0.246],
          [4.648, -0.002],
          [4.9, -0.002],
          [4.9, 0.24],
          [4.645, 0.246]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Ejército Mexicano",
          position: "right bottom"
        },
        info: {
          template: "mark2Content",
          images: [
            "galerias/gameRoom/MEXICANOS.png"
          ]
        }
      },
      {
        id: "mark3Content",
        visible: false,
        polylineRad: [
          [4.973, 0.183],
          [4.975, -0.045],
          [5.125, -0.045],
          [5.127, 0.169],
          [4.973, 0.183]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Ejército Francés",
          position: "right bottom"
        },
        info: {
          template: "mark3Content",
          images: [
            "galerias/gameRoom/FRANCESES.png"
          ]
        }
      },
      {
        id: "mark4",
        visible: false,
        polylineRad: [
          [5.618, -0.068],
          [5.618, -0.234],
          [5.692, -0.212],
          [5.692, -0.062],
          [5.618, -0.068]
        ],
        svgStyle: {
          fill: "rgba(50, 255, 25, 0.0)",
          stroke: "rgba(50, 255, 0, 0.95)",
          strokeWidth: "2px",
          strokeDasharray: 5
        },
        tooltip: {
          content: "Batalla del 5 de mayo de 1862",
          position: "right bottom"
        },
        info: {
          template: "mark4",
          images: [
            "galerias/gameRoom/BATALLA_PATRICIO_RAMOS_Cc.jpg"
          ]
        }
      }
    ]
  }
};
